// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PrlR","colMin":"styles_colMin__2L4Gr"};